/**
 * 菜单项：高亮文档名
*/
import React, { ReactChild } from 'react';
import i18n from '@i18next/i18n';
import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/title-highlight/config';
import { TitleHighlightFeature } from '@framework/workbench/ui/titlebar/features/title-highlight-feature';
import { MenuKey } from '../../schema/menu-schema/common';
import { loadAndShowDocsComponentVipGuide } from '@src/js/common/ark-extensions/dc-components/vip-guide';
import { GuideType } from '@src/js/common/ark-extensions/dc-components/vip-guide/types';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Controller({ menuItems: MENU_CONFIGS })
export class TitleHighLightController {
    constructor(private readonly titleHighlightFeature: TitleHighlightFeature) {}

    @Menu(MenuKey.HIGHLIGHT_TITLE, 'shouldHide')
    public shouldHide(): boolean {
        return !this.titleHighlightFeature.shouldHighlight();
    }

    @Menu(MenuKey.HIGHLIGHT_TITLE, 'onClick')
    public vipGuide(): void {
        loadAndShowDocsComponentVipGuide({
            guideType: GuideType.setPersonlizedColor,
            product: 'slide',
            onSuccess: (nextColor: string) => this.titleHighlightFeature.toggleTitleHighlight(nextColor),
            onError: () => this.titleHighlightFeature.toggleTitleHighlight(''),
        });
    }

    @Menu(MenuKey.HIGHLIGHT_TITLE, 'content')
    public titleHighlightContent(): ReactChild {
        const highlightText = this.titleHighlightFeature.titleColor
            ? i18n.t<string>('取消高亮文档名')
            : i18n.t<string>('高亮文档名');
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div id="highlight-item">{highlightText}</div>
            </div>
        );
    }

    @Menu(MenuKey.HIGHLIGHT_TITLE, 'shouldDisabled')
    public shouldDisabled() {
        // 加密文件夹中禁用
        return !SlideDataServices.PrivilegeManager()?.getPrivilegeAttribute().can_high_light_title;
    }
}
